import { StoreId } from "./store.service";

class CqrsRequest {
    constructor(data) {
        Object.assign(this, data);
        this.storeId = this.storeId || StoreId;
        this.culture = this.culture || document.documentElement.lang;
    }
}

export default class CqrsClient {

    constructor({ baseUri }) {
        this.baseUri = baseUri;
    }

    command(data) {
        return this._postJSON(this.baseUri + "Command", new CqrsRequest(data));
    }

    query(data) {
        var response = this._postJSON(this.baseUri + "Query", new CqrsRequest(data));
        return response.then(res => res.json());
    }

    _postJSON(endpoint, data) {
        this._validateTypedJSON(data);
        var response = fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
        .then(res => {
            if (!res.ok) {
                res.json().then(
                    (ex) => alert(ex.message)
                );
                throw new Error("Encountered a problem posting to server.");
            }
            return res;
        });
        return response;
    }

    _validateTypedJSON(data) {
        if (Object.keys(data)[0] !== "$type") {
            throw "First property must be $type";
        }
    }

}